'use client';

import { SliceComponentProps } from '@prismicio/react';
import React from 'react';
import EventNames from 'src/analytics/EventNames';
import { trackClick } from 'src/analytics/Events';
import { Button } from '@get-mosh/msh-shared';
import Heading from 'src/components/Heading/Heading';
import styles from './banner.module.scss';
import { Content } from '@prismicio/client';
import { Vertical } from 'src/constants/Verticals';
import { PrismicNextImage } from '@prismicio/next';

type BannerProps = SliceComponentProps<Content.BannerSlice> & {
    context: {
        pageType: string;
    };
};

const Banner = ({ slice, context }: BannerProps) => (
    <section className={styles['section-wrapper']}>
        {slice?.primary?.image?.url && (
            <picture className={styles['image-wrapper']}>
                <PrismicNextImage field={slice.primary.image} fill />
            </picture>
        )}
        <div className={styles['content-wrapper']}>
            {slice?.primary?.title && (
                <Heading centered={true} tag="p" level="h2">
                    {slice.primary.title}
                </Heading>
            )}
            <Button
                text={slice.primary.link_label ?? 'Learn More'}
                as="a"
                href={slice.primary.link_path ?? '/'}
                onClick={() => {
                    trackClick(EventNames.BUTTON_CLICKED, {
                        pageType: context.pageType,
                        vertical: slice.primary.vertical as Vertical,
                        label: slice.primary.link_label ?? '',
                        link: slice.primary.link_path ?? '/',
                        variation: slice.variation,
                        location: slice.slice_type,
                    });
                }}
            />
        </div>
    </section>
);

export default Banner;
